"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnLabels = void 0;
const react_1 = __importDefault(require("react"));
const className = 'seat-selection-aircraft';
class ColumnLabels extends react_1.default.PureComponent {
    render() {
        const { columnLabels, isAllowedToEditLabels } = this.props;
        return (react_1.default.createElement("div", { className: `${className}__row ${className}__row--labels` },
            react_1.default.createElement("div", { className: `${className}__column` }),
            columnLabels.map((label, idx) => {
                return (react_1.default.createElement("div", { key: `rssac::${idx}::${label}`, className: `${className}__column` }, label && (react_1.default.createElement("input", { type: 'text', className: `${className}__column-label`, defaultValue: label, readOnly: !isAllowedToEditLabels }))));
            }),
            react_1.default.createElement("div", { className: `${className}__column` })));
    }
}
exports.ColumnLabels = ColumnLabels;
ColumnLabels.defaultProps = {
    columnLabels: [],
    isAllowedToEditLabels: false,
};
//# sourceMappingURL=index.js.map